import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.473 5.527a.667.667 0 0 0-.946 0L8 7.06 6.473 5.527a.67.67 0 1 0-.946.946L7.06 8 5.527 9.527a.667.667 0 0 0 .217 1.092.67.67 0 0 0 .73-.146L8 8.94l1.527 1.533a.666.666 0 0 0 .946 0 .665.665 0 0 0 0-.946L8.94 8l1.533-1.527a.666.666 0 0 0 0-.946m2.24-2.24a6.666 6.666 0 1 0-9.426 9.426 6.667 6.667 0 1 0 9.426-9.426m-.94 8.486A5.334 5.334 0 1 1 13.333 8a5.3 5.3 0 0 1-1.56 3.773"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })